import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {FormGroup,Validators,FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {Observable,Subject} from 'rxjs';


declare var $:any;
declare var fbq:any;

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],

})
export class FooterComponent implements OnInit {
  display:boolean=false;
  userId:number=-1;
  planId:number=-1;
  completeModule: number = 0;
   userModuleQuestions:any[]=[];
   currentQuestions:any[]=[];
  reminderSubscription:boolean=false;
  pricinginfo:FormGroup;
  isPricingModal:boolean=false;
  planData:any[]=[];
  public firstQuestion:any[]=[];
  currentIndex:number=0;
  responseMessage:string="";
  timeLap:number=20000;
  private sessionSub = new Subject<string>();
  userTypeId:number=-1;





  constructor(private service:DataService,private fb:FormBuilder,private router:Router) {
    this.pricinginfo=this.fb.group({
      'pricing':['', Validators.required],
      'couponCode': ['']
    });







   }

   ngDoCheck(){
     this.planId=localStorage.getItem('planId')==null ? -1 : parseInt(localStorage.getItem('planId'));
   }

  ngOnInit() {

    this.userId=localStorage.getItem("UserId")!=null ? parseInt(localStorage.getItem("UserId")) : -1;
    this.planId=this.userId!=-1 ? parseInt(localStorage.getItem("planId")) : -1;
    this.userTypeId=localStorage.getItem('UserTypeId')==null ? -1 : parseInt(localStorage.getItem('UserTypeId'));
    this.completeModule = parseInt(sessionStorage.getItem('ModuleCompleted'));
    if(sessionStorage.getItem('reminder-subscription')!=null)
    this.reminderSubscription=sessionStorage.getItem('reminder-subscription')=='true' ? true : false
    if(sessionStorage.getItem('currentUrl')!=null){
      this.display=sessionStorage.getItem('currentUrl')=='/' ? true : false
     //// console.log("display is " +this.display);
    }
    this.service.watchStorage().subscribe(()=>{
      this.userTypeId=localStorage.getItem('UserTypeId')==null ? -1 : parseInt(localStorage.getItem('UserTypeId'));

      if(sessionStorage.getItem('reminder-subscription')!=null){
          this.reminderSubscription=sessionStorage.getItem('reminder-subscription')=='true' ? true : false

      }
      this.userId=localStorage.getItem("UserId")!=null ? parseInt(localStorage.getItem("UserId")) : -1;
      this.planId=this.userId!=-1 ? parseInt(localStorage.getItem("planId")) : -1;
        this.completeModule = parseInt(sessionStorage.getItem('ModuleCompleted'));

        this.display=sessionStorage.getItem('currentUrl')=='/' ? true : false;
         //// console.log("display is " +this.display);
          if(this.display==true){
            if(sessionStorage.getItem('CurrentTime')!=null){

                if(sessionStorage.getItem('CurrentTime')=="0"){
                 //// console.log("in watchstorage")
                  this.firstQuestion=[];
                    this.getModuleUserQuesn();
                }

                  // else{
                  //   if(new Date() >= new Date(sessionStorage.getItem('CurrentTime'))){
                  //
                  //     this.getModuleUserQuesn();
                  //   }
                  //
                  // }
            }

          }
    })

    this.watchSession().subscribe(()=>{

         //// console.log('working fine in watchsession');
      if(sessionStorage.getItem('elapsedTime')!=null){
        this.timeLap=parseInt(sessionStorage.getItem('elapsedTime'))
        setInterval(()=>{
         //// console.log('working fine in interval');
          if(sessionStorage.getItem('CurrentTime')!=null && sessionStorage.getItem('CurrentTime')!="0"){
            if(new Date() > new Date(sessionStorage.getItem('CurrentTime'))){
              this.getModuleUserQuesn();
             //// console.log(this.timeLap);
            }
          }

        },this.timeLap)
      }
    })
    if(sessionStorage.getItem('CurrentTime')!=null && this.timeLap==20000){
      var d1:any=new Date();
      var d2:any=new Date(sessionStorage.getItem('CurrentTime'));
      this.timeLap=d2-d1;
      setTimeout(()=>{
       //// console.log('working fine in timeout');
        if(sessionStorage.getItem('CurrentTime')!=null && sessionStorage.getItem('CurrentTime')!="0"){
          if(new Date() > new Date(sessionStorage.getItem('CurrentTime'))){
            this.getModuleUserQuesn();
           //// console.log(this.timeLap);
          }
        }

      },this.timeLap)
    }
    if(sessionStorage.getItem('CurrentTime')!=null && sessionStorage.getItem('CurrentTime')=="0"){
        this.getModuleUserQuesn();
    }
  }



  getModuleUserQuesn(){

    const inputJson={
      "UserId":this.userId
    }
    if(this.userId==-1){

      return false;
    }
    else {
      this.service.GetModuleUserQuesn(inputJson)
      .subscribe(
        (result:any[])=>{
          if(result["Status"]=="Success"){

          this.userModuleQuestions=result['UserQuestionData'];
         //// console.log("questions from service");
         //// console.log(this.userModuleQuestions);

          if(this.userModuleQuestions.length>0){
            this.currentQuestions=this.userModuleQuestions.map(x=>Object.assign(x,{}));
            this.currentQuestions.forEach((item,index)=>{
              item['Index']=index;

            });
           //// console.log('currentQuestions' );
           //// console.log(this.currentQuestions);
              this.firstQuestion=this.currentQuestions.filter(ques=>ques.Index==0);
          }


         //// console.log("first Question");
         //// console.log(this.firstQuestion);
          } else {
            this.service.alert(result['Message'],"error");
          }
        },
        (error)=>{
         //// console.log(error);
        }
      )
    }
  }

  goToNextQues(pvarIndex,pvarId,pvarChoice){
    var nextQuesId=parseInt(pvarIndex)+1;
    let actionQuestion:any[]=this.currentQuestions.filter(ques=>ques.Index == pvarIndex);
    this.firstQuestion=this.currentQuestions.filter(ques=>ques.Index == nextQuesId)
    const inputJson= {

       "Ans":pvarChoice,
       "Id":pvarId
    }
    if(pvarChoice==1){
      if(actionQuestion.length>0){
        // if(actionQuestion[0]['QuestionId']==1){
        //   let moduleName:string=actionQuestion[0]['ModuleName'].split(' ').join('-');
        //   this.router.navigate(['module',moduleName,actionQuestion[0]['ModuleId']]);
        // }
        if(actionQuestion[0]['QuestionId']==2){

          this.router.navigate(['module-by-theme',actionQuestion[0]['ThemeId']]);
        }

        if(actionQuestion[0]['QuestionId']==3){

          this.router.navigate(['all-modules','Trending']);
        }

        if(actionQuestion[0]['QuestionId']==4){

          this.router.navigate(['all-modules','Free']);
        }

        if(actionQuestion[0]['QuestionId']==5){

          this.router.navigate(["all-modules","Editor's Pick"]);
        }

        if(actionQuestion[0]['QuestionId']==6){

          this.router.navigate(['all-modules','New']);
        }
      }
    }
    if(this.firstQuestion.length==0){
      var d1:any=new Date();
      var d2:any=new Date(d1);
      d2.setMinutes(d1.getMinutes()+7);
      this.timeLap=d2-d1;
      sessionStorage.setItem('CurrentTime',d2.toString());
      sessionStorage.setItem('elapsedTime',this.timeLap.toString());
      this.sessionSub.next('changed');


    }

   //// console.log(inputJson);
    this.service.UpdateModuleUserQuesn(inputJson)
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){

        } else {
          this.service.alert(result['Message'],"error");
        }
      },
      (error)=>{
       //// console.log(error);
      }
    )
  }

  couponCode = "";
  searchEmpety(){
    var planId = this.pricinginfo.controls['pricing'].value;
    if(this.couponCode.length == 1){
      this.couponAmount = 0
      this.couponId = -1;
      // this.netPayableAmount = planId == 1 ? 3999 : 8999;
      this.discountAmount = 0;
    }
  }

  couponAmount: any = 0;
  couponId: any = -1;
  netPayableAmount: any = 0;
  discountAmount : any = 0;

  openPricingModal(){
    this.service.GetPlan()
    .subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
            this.planData=result['PlanData'];
        } else {
          this.service.alert(result['Message'],"error");
        }
      },
      (error)=>{
       //// console.log(error);
      }
    )

    this.couponAmount= 0;
    this.couponId = -1;
    this.netPayableAmount = 0;
    this.discountAmount = 0;
    this.responseMessage= '';
    this.pricinginfo = this.fb.group({
      'pricing':['', Validators.required],
      'couponCode': ['']
    });
    $('#hideme').removeClass('hideall');
    this.isPricingModal=true;
  }

  closePricingModal(){
    this.isPricingModal=false;
  }

  //On plan select
  slectedPlanId: any;
  handlePlanChange(pvarId, pvarPlanId){
    this.slectedPlanId = pvarPlanId;
    if(pvarId == -1){
      this.couponAmount = 0
      this.couponId = -1;
      this.netPayableAmount = 0;
      this.discountAmount = 0;
      this.responseMessage="";
      return false;
    }
    else {
      var c: any = (parseInt(pvarId) * this.couponAmount) / 100;
      this.discountAmount = parseInt(c);
      var d: any = parseInt(pvarId) - this.discountAmount
      this.netPayableAmount = parseInt(d);
    }
  }

  //Submit paln
  addPricing(priceform){
    const _successUrl = "https://stratgist.com/workSmarts/thanks";
    const _failureUrl= "https://stratgist.com/workSmarts";
   //// console.log(priceform);
    // const _successUrl = "http://52.66.183.31/pbweb/";
    // const _failureUrl= "http://52.66.183.31/pbweb/";
    if(priceform.pricing != '' && priceform.pricing != -1){
      // const inputData = {
      //     "Amount": this.netPayableAmount, //priceform.pricing == 1 ? 3999 : 8999,
      //     "PlanId": parseInt(priceform.pricing),
      //     "UserId": this.userId,
      //     "FailureUrl":_failureUrl,
      //     "SuccessUrl":_successUrl,
      //     "Code": priceform.couponCode,
      //     "CoupanAmount": this.couponAmount,
      //     "IsCoupan": priceform.couponCode ? true : false
      // };
      const inputData={
       "Amount":this.netPayableAmount,
       "CouponId": this.couponId,
       "FailureUrl":_failureUrl,
       "PlanId": parseInt(this.slectedPlanId), //parseInt(priceform.pricing),
       "SuccessUrl":_successUrl,
       "UserId":this.userId
     }
     //// console.log(inputData);
      this.service.PaymentForModule(inputData)
      .subscribe(
        (response)=>{
         //// console.log(response);
          if(response['Status'] =="Success"){
             this.isPricingModal = false;
             this.closePricingModal();
             location.href = "https://stratgist.com/MasterProjectBytePayment/?Paymentid=" + response['Id'];
             // fbq('track', 'AddPaymentInfo');
                // location.href = "http://52.66.183.31/MasterProjectBytePayment/?Paymentid=" + response['Id'];
          }else{
            this.service.alert(response['Message'],"error");
          }
        },
        (error)=>{
          this.service.alert(error, 'error');
        }
      )
    }else{
      this.pricinginfo = this.fb.group({
        'pricing':['', Validators.required],
        'couponCode': ['']
      });
      this.isPricingModal=false;
      return false;
    }
  }

  snoozeReminderSubscription(){

    $('#subsquestion').removeClass('fadeInUp').addClass('fadeOutDown');
    setTimeout(()=>{
      this.reminderSubscription=false;
      sessionStorage.setItem('reminder-subscription','false');
    },500)
  }
  applyCode(pricinginfo){
   //// console.log(pricinginfo);
    const inputData = {
      "CouponCode": pricinginfo.couponCode
    }
    this.service.applyCoupon(inputData)
    .subscribe(
      (res: any[])=>{
        if(res['Status'] == "Success"){
          this.responseMessage="Coupon Applied";
         //// console.log(res);
          this.couponId = res['CouponId'];
          this.couponAmount = parseFloat(res['Amount']);
            var c: any = (parseInt(pricinginfo.pricing) * this.couponAmount) / 100;
            this.discountAmount = parseInt(c);
            var d: any = parseInt(pricinginfo.pricing) - this.discountAmount
            this.netPayableAmount = parseInt(d);
        }else{
          this.service.alert(res['Message'],"error");
          this.responseMessage=res['Message'];
          var planId = this.pricinginfo.controls['pricing'].value;
          this.couponAmount = 0
          this.couponId = -1;
          this.netPayableAmount = pricinginfo.pricing
          this.discountAmount = 0;
        }
      },
      (error)=>{
          this.service.alert(error,"error");

      }
    )
  }

  watchSession(){
    return this.sessionSub.asObservable();
  }




}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/footer/footer.component.ts